import { unstable__Button as Button } from "@hagerty/react-components";

import { ReactComponent as Logo } from "./img/driversClubLogo.svg";
import { useUrls } from "../../app/Providers/AppContext";
import { TagAction } from "../../types/Tag.types";
import styles from "./NoDriversClub.module.scss";
import { mt } from "../../utils/tracking";

export const titleText = "Unlock all your benefits";
export const linkText = "Learn more";

export const benefits = [
  "Exclusive automotive offers",
  "Expert support",
  "Members-only experiences",
  "Original content",
  "Emergency services",
] as const;

export const learnMoreTagAction: TagAction = {
  actionType: "link",
  actionName: linkText,
};

export const NoDriversClub = () => {
  const urls = useUrls();

  return (
    <div className={styles.container}>
      <Logo className={styles.logo} />
      <h2>{titleText}</h2>
      <ul>
        {benefits.map((benefit, index) => (
          <li key={index}>{benefit}</li>
        ))}
      </ul>
      <Button
        variant="solid"
        color="blueberry"
        size="small"
        href={urls.hdc.redeemBenefits}
        className={styles.button}
        onClick={() => mt.trackAction(learnMoreTagAction)}
      >
        {linkText}
      </Button>
    </div>
  );
};
